import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgxSpinnerService } from 'ngx-spinner';
import { CRMResposta } from 'src/app/models/crm/crmresposta';
import { StatusCadastroEnum } from 'src/app/models/enum';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CrmrespostaService } from 'src/app/services/crm/crmresposta.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';

@Component({
  selector: 'app-alterar-status-oportunidade',
  templateUrl: './alterar-status-oportunidade.component.html',
  styleUrls: ['./alterar-status-oportunidade.component.scss']
})
export class AlterarStatusOportunidadeComponent implements OnInit {
  tipoResposta = 0;
  lote = false;
  status = [{id: 1, descricao: 'Perder'}, {id: 3, descricao: 'Congelar'}, {id: 4, descricao: 'Excluir'}];
  statusSelecionado = 1;
  respostas: CRMResposta[] = [];
  respostaSelecionada;
  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<AlterarStatusOportunidadeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private notificacaoService: NotificacaoService,
    private spinner: NgxSpinnerService, private respostaService: CrmrespostaService,
    private carregandoService: CarregandoService
  ) { }

  ngOnInit() {
    this.tipoResposta = this.data.tipoResposta;
    this.lote = this.data.lote;
    this.buscarRespostas();
  }

  buscarRespostas() {
    this.carregandoService.mostra('buscaRespostas');

    this.respostaService.consultarRespostas(this.tipoResposta).subscribe(respostas => {
      this.respostas = respostas.filter(t => t.statusCadastro === StatusCadastroEnum.Ativo);
      this.carregandoService.esconde('buscaRespostas');
    }, (erro) => {
      this.carregandoService.esconde('buscaRespostas');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  selelcionar() {
    if (!this.lote) {
      this.dialogRef.close(this.respostaSelecionada);
    }
    else {
      this.dialogRef.close({ status: this.statusSelecionado, idResposta: this.respostaSelecionada});
    }
  }
}